import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { debounceTime, filter, first } from 'rxjs/operators';

import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  version: string;
  path: string;

  private readonly http = inject(HttpClient);
  private readonly router = inject(Router);

  constructor() {
    if (typeof window !== 'undefined') {
      window.addEventListener('focus', () => this.checkVersion());
    }
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        debounceTime(30000)
      )
      .subscribe(() => this.checkVersion());
  }

  checkVersion(): void {
    if (!this.version || !environment.production) {
      return;
    }
    this.http
      .get(`${this.path}/version.json?t=${new Date().getTime()}`)
      .pipe(first())
      .subscribe((response: any) => {
        if (Object.prototype.hasOwnProperty.call(response, 'version') && response.version !== this.version) {
          location.reload();
        }
      });
  }

  setVersion(version: string, path = ''): void {
    this.version = version;
    this.path = path;
  }
}
